export const TXTCLI_Incorrect_Information_Entered = {
  "id": "TXTCLI_Incorrect_Information_Entered",
  "defaultMessage": "Incorrect Information Entered"
} as const;

export const TXTCLI_Your_name_and_date_of_birth_is_ELL_1 = {
  "id": "TXTCLI_Your_name_and_date_of_birth_is_ELL_1",
  "defaultMessage": "Your name and date of birth is not permitted in your password."
} as const;

export const TXTWCL_At_least_one_capital_letter_XA_ELL = {
  "id": "TXTWCL_At_least_one_capital_letter_XA_ELL",
  "defaultMessage": "At least one capital letter (A-Z)"
} as const;

export const TXTWCL_Please_enter_valid_Personal_Nu_ELL = {
  "id": "TXTWCL_Please_enter_valid_Personal_Nu_ELL",
  "defaultMessage": "Please enter valid Personal Number of Foreigner"
} as const;

export const TXTWCL_Please_enter_valid_Uniform_Civ_ELL = {
  "id": "TXTWCL_Please_enter_valid_Uniform_Civ_ELL",
  "defaultMessage": "Please enter valid Uniform Civil Number"
} as const;

export const TXTWCL_The_following_characters_are_n_ELL = {
  "id": "TXTWCL_The_following_characters_are_n_ELL",
  "defaultMessage": "The following characters are not valid: {0}"
} as const;

export const TXTWCL_Invalid_phone_number = {
  "id": "TXTWCL_Invalid_phone_number",
  "defaultMessage": "Invalid phone number"
} as const;

export const TXTWCL_Must_be_shorter_than_N0_charac_ELL = {
  "id": "TXTWCL_Must_be_shorter_than_N0_charac_ELL",
  "defaultMessage": "Must be shorter than {0} characters"
} as const;

export const TXTWCL_At_least_one_symbol_XeXgX_XX = {
  "id": "TXTWCL_At_least_one_symbol_XeXgX_XX",
  "defaultMessage": "At least one symbol (e.g. !@#$)"
} as const;

export const TXTCLI_Email_address_is_not_valid = {
  "id": "TXTCLI_Email_address_is_not_valid",
  "defaultMessage": "Email address is not valid"
} as const;

export const TXTWCL_Must_contain_at_least_3_of_the_ELL = {
  "id": "TXTWCL_Must_contain_at_least_3_of_the_ELL",
  "defaultMessage": "Must contain at least 3 of the following: (0-9), (a-z), (A-Z), symbol (for example !@#$)"
} as const;

export const TXTCLI_Please_try_againX = {
  "id": "TXTCLI_Please_try_againX",
  "defaultMessage": "Please try again."
} as const;

export const TXTCLI_The_SSN_that_you_have_entered__ELL = {
  "id": "TXTCLI_The_SSN_that_you_have_entered__ELL",
  "defaultMessage": "The SSN that you have entered does not match the SSN that you previously entered."
} as const;

export const TXTWCL_Must_contain_at_least_one_digi_ELL = {
  "id": "TXTWCL_Must_contain_at_least_one_digi_ELL",
  "defaultMessage": "Must contain at least one digit (0-9)"
} as const;

export const TXTCLI_User_ID_XN0X_is_not_availlable_ELL = {
  "id": "TXTCLI_User_ID_XN0X_is_not_availlable_ELL",
  "defaultMessage": "Username ''{0}'' is not available. Please choose one of these suggestions or try another username."
} as const;

export const TXTWCL_Unable_to_validate_usernameX = {
  "id": "TXTWCL_Unable_to_validate_usernameX",
  "defaultMessage": "Unable to validate username."
} as const;

export const TXTWCL_Your_UserID_must_not_contain_s_ELL = {
  "id": "TXTWCL_Your_UserID_must_not_contain_s_ELL",
  "defaultMessage": "Your username must not contain special characters or spaces "
} as const;

export const TXTWCL_The_address_you_have_entered_i_ELL_1 = {
  "id": "TXTWCL_The_address_you_have_entered_i_ELL_1",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "The address you have entered is invalid."
} as const;

export const TXTCLI_Password_may_not_start_with_th_ELL = {
  "id": "TXTCLI_Password_may_not_start_with_th_ELL",
  "defaultMessage": "Password may not start with the letters 'tmp'"
} as const;

export const TXTCLI_Required = {
  "id": "TXTCLI_Required",
  "defaultMessage": "Required"
} as const;

export const TXTWCL_Check_thatXs_correct_and_try_a_ELL = {
  "id": "TXTWCL_Check_thatXs_correct_and_try_a_ELL",
  "defaultMessage": "Check that's correct and try again"
} as const;

export const TXTWCL_Consecutive_hyphens_are_not_al_ELL = {
  "id": "TXTWCL_Consecutive_hyphens_are_not_al_ELL",
  "defaultMessage": "Consecutive hyphens are not allowed."
} as const;

export const TXTWCL_SorryX_something_went_wrongX = {
  "id": "TXTWCL_SorryX_something_went_wrongX",
  "defaultMessage": "Sorry, something went wrong."
} as const;

export const TXTWCL_No_consecutive_spaces_are_allo_ELL = {
  "id": "TXTWCL_No_consecutive_spaces_are_allo_ELL",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "No consecutive spaces are allowed."
} as const;

export const TXTWCL_Does_not_include_N0 = {
  "id": "TXTWCL_Does_not_include_N0",
  "defaultMessage": "Does not include {0}"
} as const;

export const TXTWCL_Special_characters_are_not_all_ELL = {
  "id": "TXTWCL_Special_characters_are_not_all_ELL",
  "defaultMessage": "Special characters are not allowed."
} as const;

export const TXTWCL_SorryX_you_need_to_be_N0_or_ol_ELL = {
  "id": "TXTWCL_SorryX_you_need_to_be_N0_or_ol_ELL",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "Sorry, you need to be {0} or older to join us"
} as const;

export const TXTWCL_Try_refreshing_the_pageX = {
  "id": "TXTWCL_Try_refreshing_the_pageX",
  "defaultMessage": "Try refreshing the page."
} as const;

export const TXTCLI_PO_Box_addresses_are_not_permi_ELL = {
  "id": "TXTCLI_PO_Box_addresses_are_not_permi_ELL",
  "defaultMessage": "PO Box addresses are not permitted. Please enter the residential address where you live."
} as const;

export const TXTWCL_Please_enter_a_valid_postcode__ELL = {
  "id": "TXTWCL_Please_enter_a_valid_postcode__ELL",
  "defaultMessage": "Please enter a valid postcode/ZIP code."
} as const;

export const TXTCLI_Please_double_check_and_try_to_ELL = {
  "id": "TXTCLI_Please_double_check_and_try_to_ELL",
  "defaultMessage": "Please double check and try to enter your Brazilian CPF (Cadastro de Pessoas F\\355sicas) code again."
} as const;

export const TXTCLI_Please_specify_3_digit_institu_ELL = {
  "id": "TXTCLI_Please_specify_3_digit_institu_ELL",
  "defaultMessage": "Please specify 3 digit institution ID"
} as const;

export const TXTCLI_Please_specify_5_digit_branch__ELL = {
  "id": "TXTCLI_Please_specify_5_digit_branch__ELL",
  "defaultMessage": "Please specify 5 digit branch transit"
} as const;

export const TXTCLI_Must_be_at_least_N0_characters_ELL = {
  "id": "TXTCLI_Must_be_at_least_N0_characters_ELL",
  "defaultMessage": "Must be at least {0} characters long"
} as const;

export const TXTWCL_Please_enter_phone_number = {
  "id": "TXTWCL_Please_enter_phone_number",
  "defaultMessage": "Please enter phone number"
} as const;

export const TXTCLI_Social_Insurance_NumberX_wrong_ELL = {
  "id": "TXTCLI_Social_Insurance_NumberX_wrong_ELL",
  "defaultMessage": "Social Insurance Number: wrong format"
} as const;

export const TXTCLI_Street_address_must_be_at_leas_ELL = {
  "id": "TXTCLI_Street_address_must_be_at_leas_ELL",
  "defaultMessage": "Street address must be at least 4 characters long."
} as const;

export const TXTWCL_Must_not_start_or_end_with_a_s_ELL = {
  "id": "TXTWCL_Must_not_start_or_end_with_a_s_ELL",
  "defaultMessage": "Must not start or end with a space"
} as const;

export const TXTCLI_The_IBAN_you_have_entered_is_i_ELL = {
  "id": "TXTCLI_The_IBAN_you_have_entered_is_i_ELL",
  "defaultMessage": "The IBAN you have entered is incorrect."
} as const;

export const TXTCLI_The_SIN_you_entered_does_not_m_ELL = {
  "id": "TXTCLI_The_SIN_you_entered_does_not_m_ELL",
  "defaultMessage": "The SIN you entered does not match what you entered on your previous deposit.\n\nPlease try again."
} as const;

export const TXTCLI_The_bank_routing_number_you_pr_ELL = {
  "id": "TXTCLI_The_bank_routing_number_you_pr_ELL",
  "defaultMessage": "The bank routing number you provided is invalid. Please verify and try again."
} as const;

export const TXTCLI_The_information_entered_in_the_ELL = {
  "id": "TXTCLI_The_information_entered_in_the_ELL",
  "defaultMessage": "The information entered in the \"Your Bank Account Number\" field and the \"Your IBAN\" field are not for the same account."
} as const;

export const TXTCLI_The_password_you_have_entered__ELL = {
  "id": "TXTCLI_The_password_you_have_entered__ELL",
  "defaultMessage": "The password you have entered is incorrect. Please try again."
} as const;

export const TXTCLI_The_street_address_entered_app_ELL = {
  "id": "TXTCLI_The_street_address_entered_app_ELL",
  "defaultMessage": "The street address entered appears to be invalid.\n\nPlease try again using one of the following formats: street number and name, rural route and box number, highway contract route and box number, Post Office box number or PSC (CMR or Unit) number and box number.\nAdditional address details may also be included in this field."
} as const;

export const TXTCLI_The_voucher_code_you_have_ente_ELL = {
  "id": "TXTCLI_The_voucher_code_you_have_ente_ELL",
  "defaultMessage": "The voucher code you have entered appears to be invalid. Please verify the number and try again."
} as const;

export const TXTCLI_Wrong_account_number_format = {
  "id": "TXTCLI_Wrong_account_number_format",
  "defaultMessage": "Wrong account number format"
} as const;

export const TXTWCL_Ensure_your_CNP_matches_your_d_ELL = {
  "id": "TXTWCL_Ensure_your_CNP_matches_your_d_ELL",
  "defaultMessage": "Ensure your CNP matches your date of birth"
} as const;

export const TXTWCL_Invalid_CNPX_Please_try_againX = {
  "id": "TXTWCL_Invalid_CNPX_Please_try_againX",
  "defaultMessage": "Invalid CNP. Please try again."
} as const;

export const TXTWCL_Invalid_codeX_Please_try_again_ELL = {
  "id": "TXTWCL_Invalid_codeX_Please_try_again_ELL",
  "defaultMessage": "Invalid code. Please try again."
} as const;

export const TXTWCL_Please_enter_a_valid_middle_na_ELL = {
  "id": "TXTWCL_Please_enter_a_valid_middle_na_ELL",
  "defaultMessage": "Please enter a valid middle name."
} as const;

export const TXTWCL_The_card_number_entered_is_not_ELL = {
  "id": "TXTWCL_The_card_number_entered_is_not_ELL",
  "defaultMessage": "The card number entered is not valid. Please enter a valid card number."
} as const;

export const TXTWCL_Your_CNP_must_be_13_digitsX = {
  "id": "TXTWCL_Your_CNP_must_be_13_digitsX",
  "defaultMessage": "Your CNP must be 13 digits."
} as const;

export const TXTSRV_Please_enter_a_valid_bonus_cod_ELL = {
  "id": "TXTSRV_Please_enter_a_valid_bonus_cod_ELL",
  "defaultMessage": "Please enter a valid bonus code."
} as const;

export const TXTCLI_The_Fiscal_Code_you_entered_is_ELL = {
  "id": "TXTCLI_The_Fiscal_Code_you_entered_is_ELL",
  "defaultMessage": "The Fiscal Code you entered is incorrect"
} as const;